import { cn } from '@bem-react/classname';

export const cnKhPage = cn('KhPage');
